// @ts-nocheck
import Textarea from '@/components/Textarea';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import {
  Button,
  Drawer,
  Grid,
  Row,
  Col,
  Panel,
  Input,
  Nav,
  FlexboxGrid,
  SelectPicker,
  useToaster,
  Message,
  Checkbox
} from 'rsuite';

const BuyerDrawer = ({ close, selectedTableData }) => {
  const toaster = useToaster();
  const [activeButton, setActiveButton] = useState(1);
  const [activityData, setActivityData] = useState({ opened: [], shortlisted: [], query: [] });
  const { openedproduct, shortlistproduct, sentquery, id, loginemail } = selectedTableData;

  const sentQueryProductIds = sentquery.map(item => item.productid) || [];
  const [active, setActive] = React.useState(1);
  const selectData = ['Quotation', 'Show Pricing', 'Need Sample', 'Order Confirm'].map(item => ({
    label: item,
    value: item
  }));
  const productCountsArray = Object.values(
    openedproduct.reduce((acc, item) => {
      const productId = item.productid;
      acc[productId] = { ...acc[productId], count: (acc[productId]?.count || 0) + 1, productId };
      return acc;
    }, {})
  );

  const productCountsArray1 = Object.values(
    shortlistproduct.reduce((acc, item) => {
      const productId = item.productid;
      acc[productId] = { ...acc[productId], count: (acc[productId]?.count || 0) + 1, productId };
      return acc;
    }, {})
  );

  const handleButtonClick = buttonIndex => {
    setActiveButton(buttonIndex);
  };

  useEffect(() => {
    const fetchData = async (productCountsArray, activityType) => {
      // console.log('productCountsArray');
      // console.log(productCountsArray);
      const productvarid = productCountsArray.map(id => `filters[id][$eq]=${id}`).join('&');
      try {
        const requests = productCountsArray.map(({ productId }) =>
          axios.get(`${globalIP}/api/products/${productId}?populate=*`)
        );
        const responses = await Promise.all(requests);

        const data = responses.map((response, index) => {
          const { id } = response.data.data;
          const countObject = productCountsArray.find(item => item.productId == id);
          return {
            ...response.data.data,
            count: countObject ? countObject.count : 0
          };
        });
        setActivityData(prev => ({ ...prev, [activityType]: data }));
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (openedproduct.length) {
      fetchData(productCountsArray, 'opened');
    }
    if (shortlistproduct.length) {
      fetchData(productCountsArray1, 'shortlisted');
    }
  }, [selectedTableData]);
  useEffect(() => {
    const fetchData = async activityType => {
      const sentQueryProductIds = sentquery.map(item => item.productid) || [];
      const productvarid = sentQueryProductIds.map(id => `filters[id][$eq]=${id}`).join('&');

      try {
        const [productResponse, variantResponse] = await Promise.all([
          fetch(`${globalIP}/api/products?${productvarid}&populate=*&pagination[page]=1`),
          fetch(`${globalIP}/api/variant-products?${productvarid}&populate=*&pagination[page]=1`)
        ]);

        const [productData, variantData] = await Promise.all([
          productResponse.json(),
          variantResponse.json()
        ]);
        const combinedData = sentQueryProductIds.map(id => {
          const productResponse = productData.data.find(item => item.id == id);
          const variantResponse = variantData.data.find(item => item.id == id);
          const responseData = productResponse || variantResponse;

          if (responseData) {
            const { id } = responseData;
            const countObject = sentquery.find(item => item.productid == id);
            return {
              ...responseData,
              query: countObject?.query,
              price: countObject?.price,
              remark: countObject?.remark,
              queryId: countObject?.id,
              enqId: countObject?.enqcd,
              reply: countObject?.reply
            };
          }
          return null;
        });
        setActivityData(prev => {
          const updatedData = {
            ...prev,
            [activityType]: combinedData.filter(item => item !== null)
          };
          // console.log('Updated Activity Data:', updatedData);
          return updatedData;
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData('query');
  }, [sentquery, globalIP]);

  const [selectedQueryData, setSelectedQueryData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const data = await axios.get(`${globalIP}/api/clientactivities/${id}?populate=*`);
      // console.log(data.data.data.attributes.sentquery, 'kkkkkkkkkkkkkkkkk');
      setSelectedQueryData(data.data.data.attributes.sentquery);
    };
    fetchData();
  }, [id]);

  const items = {
    1: <Item1 activityData={activityData.opened} />,
    2: <Item2 activityData={activityData.shortlisted} />,
    3: (
      <Item3
        activityData={activityData.query}
        selectData={selectData}
        id={id}
        selectedQueryData={selectedQueryData}
        loginemail={loginemail}
        toaster={toaster}
        close={close}
      />
    )
  };

  return (
    <Drawer open={true} onClose={close} size="md">
      <Drawer.Header>
        <Drawer.Title>Activity</Drawer.Title>
      </Drawer.Header>
      <Drawer.Body>
        <Navbar appearance="tabs" reversed active={activityData} onSelect={setActiveButton} />
        {items[activeButton]}
      </Drawer.Body>
    </Drawer>
  );
};

export default BuyerDrawer;

const memoizedItem1 = React.memo(({ activityData }) => {
  return (
    <FlexboxGrid justify="start" style={{ textAlign: 'center' }}>
      {activityData.map(({ id, attributes, count }, index) => (
        <FlexboxGrid.Item as={Col} colspan={24} md={8} key={id}>
          <div className="col-md-3">
            <Panel
              className="box"
              bordered
              bodyFill
              style={{ display: 'inline-block', width: '100%', height: '300px' }}
            >
              <div>
                <img
                  src={`${globalIP}${attributes.CoverImage.data.attributes.url}`}
                  alt="Placeholder"
                  className="imgp"
                />
              </div>
              <Panel style={{ paddingTop: 0 }}>
                <div style={{ textAlign: 'center' }}>
                  <h6 style={{ fontSize: '12px' }}>Product name: {attributes.ProductName}</h6>
                  <span style={{ fontSize: '11px' }}>Alias code: {attributes.ProductId}</span>
                  <br />
                  <span style={{ fontSize: '11px' }}>Count: {count}</span>
                </div>
              </Panel>
            </Panel>
          </div>
        </FlexboxGrid.Item>
      ))}
    </FlexboxGrid>
  );
});

const memoizedItem2 = React.memo(({ activityData }) => (
  <FlexboxGrid justify="start" style={{ textAlign: 'center' }}>
    {activityData.map(({ id, attributes, count }, index) => (
      <FlexboxGrid.Item as={Col} colspan={24} md={8} key={id}>
        <div className="col-md-3">
          <Panel
            className="box"
            bordered
            bodyFill
            style={{ display: 'inline-block', width: '100%', height: '300px' }}
          >
            <div>
              <img
                src={`${globalIP}${attributes.CoverImage.data.attributes.url}`}
                alt="Placeholder"
                className="imgp"
              />
            </div>
            <Panel style={{ paddingTop: 0 }}>
              <div style={{ textAlign: 'center' }}>
                <h6 style={{ fontSize: '12px' }}>Product name: {attributes.ProductName}</h6>
                <span style={{ fontSize: '11px' }}>Alias code: {attributes.ProductId}</span>
              </div>
            </Panel>
          </Panel>
        </div>
      </FlexboxGrid.Item>
    ))}
  </FlexboxGrid>
));

const memoizedItem3 = React.memo(
  ({ activityData, selectData, id, selectedQueryData, loginemail, toaster, close }) => {
    // console.log(activityData);
    const [checkValue, setCheckValue] = useState([]);
    const [sendQueryId, setSendQueryId] = useState();
    const formik = useFormik({
      initialValues: {
        reply: '',
        id: ''
      },
      onSubmit: async values => {
        try {
          const enqIds = new Set();
          for (const item of checkValue) {
            const responses = await axios.get(`${globalIP}/api/clientactivities/${id}?populate=*`);
            const sentQueries = responses.data.data.attributes.sentquery;
            const updatedSentQueries = sentQueries.map(query => {
              enqIds.add(item.enqId);
              if (query.id === item.queryId) {
                return { ...query, reply: item.reply };
              } else {
                return query;
              }
            });
            const response = await axios.put(`${globalIP}/api/clientactivities/${id}?populate=*`, {
              data: {
                sentquery: updatedSentQueries
              }
            });
          }
          if (loginemail) {
            sendEmail('', Array.from(enqIds).join(','));
          }

          close();
        } catch (error) {
          console.error('Error updating sent query:', error);
        }
      }
    });

    const sendEmail = async (to, message) => {
      const endpoint = `${globalIP}/api/email`;
      const tem = `
    <p>Dear User,</p>
    <p>Thank you for choosing ERP Daddy.</p>
    <p>Your query is resolves</p>
    <p>Your Enquiry number is ${message} </p>
    <p>Thank you for your cooperation.</p>
    <p>Best regards,</p>
    <p>ERP Daddy Private limited</p>
  `;
      const data = {
        to: loginemail,
        subject: 'Query Request',
        html: tem
      };
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (response.ok) {
          toaster.push(
            <Message showIcon type="success">
              Email sent successfully!
            </Message>,
            { placement: 'topStart' }
          );
        } else {
          console.error('Failed to send email');
          toaster.push(
            <Message showIcon type="error">
              Failed to send email
            </Message>,
            { placement: 'topStart' }
          );
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    const handleCheckBoxValue = (checked, value) => {
      if (checked) {
        setCheckValue(prev => [...prev, value]);
      } else {
        setCheckValue(prev => prev.filter(item => item.id != value.id));
      }
    };

    return (
      <Grid fluid>
        <Row gutter={16}>
          <div style={{ marginBottom: '5px' }}>
            <p>Message</p>
            <Input as="textarea" rows={3} value={selectedQueryData[0]?.Message} readOnly />
          </div>
          {activityData?.map((item, rowIndex) => {
            const { id, attributes, query, price, remark, queryId, enqId, reply } = item;
            return (
              <Col xs={24} key={item.id}>
                <Panel shaded bordered>
                  <Row>
                    <Col xs={24}>
                      <Row style={{ padding: '10px 20px' }}>
                        <Col
                          lg={8}
                          xs={24}
                          style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
                        >
                          <Checkbox
                            checked={checkValue.some(item => item.id == id)}
                            onChange={() => {
                              handleCheckBoxValue(!checkValue.some(item => item.id == id), {
                                id,
                                reply: '',
                                queryId,
                                enqId: item.ProductId
                              });
                            }}
                          />
                        </Col>
                        <Col lg={16} sm={24}>
                          <h6 style={{ fontSize: '12px' }}>{attributes.ProductName}</h6>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={8} sm={24}>
                      <div style={{ width: '150px', height: '150px', margin: 'auto' }}>
                        <img
                          src={`${globalIP}${attributes.CoverImage.data.attributes.url}`}
                          alt=""
                          style={{ width: '100%', height: '100%' }}
                        />
                      </div>
                      <Panel style={{ textAlign: 'center' }}>
                        <span style={{ fontSize: '14px' }}>Alias code: {attributes.ProductId}</span>
                      </Panel>
                    </Col>
                    <Col sm={16}>
                      <form id="reply" onSubmit={formik.handleSubmit}>
                        <Row>
                          <Col lg={12} sm={24}>
                            <SelectPicker
                              data={selectData || []}
                              id="query"
                              name="query"
                              style={{ marginBottom: '10px' }}
                              defaultValue={query}
                              block
                              readOnly
                              placeholder="Select Query"
                            />
                          </Col>
                          <Col lg={12} sm={24}>
                            <Input
                              style={{ marginBottom: '10px' }}
                              placeholder="Price"
                              readOnly
                              defaultValue={price}
                            />
                          </Col>
                          <Col xs={24}>
                            <Input
                              as="textarea"
                              rows={3}
                              placeholder="Remark"
                              readOnly
                              defaultValue={remark}
                              style={{ marginBottom: '10px' }}
                            />
                            <Input
                              as="textarea"
                              rows={3}
                              placeholder="Reply"
                              name="reply"
                              disabled={!checkValue.some(item => item.id == id)}
                              defaultValue={reply}
                              onChange={value => {
                                setCheckValue(prev => {
                                  const dataIndex = prev.findIndex(item => item.id == id);
                                  if (dataIndex != -1) {
                                    const updatedData = [...prev];
                                    updatedData[dataIndex] = {
                                      ...updatedData[dataIndex],
                                      reply: value
                                    };
                                    return updatedData;
                                  }
                                  return prev;
                                });
                              }}
                            />
                          </Col>
                        </Row>
                      </form>
                    </Col>
                  </Row>
                </Panel>
              </Col>
            );
          })}
          <Col xs={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              color="cyan"
              appearance="primary"
              size="sm"
              form="reply"
              type="submit"
              disabled={checkValue.length ? false : true}
            >
              Send
            </Button>
          </Col>
        </Row>
      </Grid>
    );
  }
);

const Navbar = ({ active, onSelect, ...props }) => {
  return (
    <Nav {...props} justified activeKey={active} onSelect={onSelect} style={{ marginBottom: 20 }}>
      <Nav.Item eventKey={1} style={{ textAlign: 'center' }}>
        Opened
      </Nav.Item>
      <Nav.Item eventKey={2} style={{ textAlign: 'center' }}>
        Selected
      </Nav.Item>
      <Nav.Item eventKey={3} style={{ textAlign: 'center' }}>
        Sent Query
      </Nav.Item>
    </Nav>
  );
};
const Item1 = memoizedItem1;
const Item2 = memoizedItem2;
const Item3 = memoizedItem3;
